import React from "react";

import { Shimmer, Stack, Text } from "@bps/fluent-ui";
import {
  FieldConfigurationVersion,
  SoftwarePackageServiceCodes
} from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useDeviceConfigurationDiff } from "@libs/api/gateways/field/field-ops-gateway.hooks";

interface Props {
  fieldDeviceId: string;
}

// The Site Agent version is reported by the tenant's site authority field device.
export const SiteAgentVersionCell: React.FC<Props> = ({ fieldDeviceId }) => {
  const { data, isLoading, error } = useDeviceConfigurationDiff(
    fieldDeviceId,
    FieldConfigurationVersion.V3_0
  );

  if (isLoading) {
    return <Shimmer width={80} />;
  }

  if (error) {
    return <Text variant="small">Unavailable</Text>;
  }

  const isSiteAgent = (pkg: { softwarePackageCode: string }) =>
    pkg.softwarePackageCode === SoftwarePackageServiceCodes.SiteAgent;

  const currentVersion = data?.reportedConfig.find(isSiteAgent)?.version;
  const desiredVersion = data?.desiredConfig.find(isSiteAgent)?.version;

  return (
    <Stack styles={{ root: { whiteSpace: "normal" } }}>
      <Text>Current: {currentVersion ?? "Not set"}</Text>
      <Text variant="small">Desired: {desiredVersion ?? "Not set"}</Text>
    </Stack>
  );
};
